import React, { useState, useEffect, Fragment } from 'react';
import Enumerable from 'linq';
import { format } from 'react-string-format';
import es from "date-fns/locale/es";
import en from "date-fns/locale/en-US";

//material mui components
import {
    Button,
    CardContent, 
    CardActions, 
    CardHeader, 
    FormControl,
    Grid, 
    InputLabel,
    MenuItem, 
    Select, 
    TextField, 
    Typography, 
} from '@mui/material';

//Material Utilidades
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

//mui/lab
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DesktopDatePicker from '@mui/lab/DesktopDatePicker';
import AdapterDateFns from '@mui/lab/AdapterDateFns';

//config home
import { MOBILE } from '../config';

//Configuracion
import { LlavesConfiguraciones } from '../../../Configuracion/Llaves/RepositorioConfig';

//Utilidades
import { useGlobalState } from '../../../Utilidades/useGlobalState';
import { ValidarPropiedad, ValidarFormatoFecha, ValidarFormatoUUID, ValidarFormatoCorreo } from '../../../Utilidades/ValidarPropiedades';
import { MostrarMensaje } from '../../../Utilidades/ManejoMensajes';

//Actions
import {
    LoadCamposrequeridos, 
    existeEstudianteInfo, 
    obtenerEstudianteInfo, 
    actualizarCliente,
    insertarCliente, 
    validarToken, 
    obtenerToken, 
    guardarMail,
    validarEmailRegistro, 
    buscarUltAdmisionPendiente
} from '../RegistroUtiles';

//Components
import { mostrarDialogoCodigoVerificacion, DialogoCodigoVerificacion } from './DialogoCodigoVerificacion';

//styles
import { StyleHome, StyleHomeHeader, modalesMensajesGenericos } from '../../Tool/Style'


const DatosPersonales = ({ deviceIs =  "DESKTOP", DatosPresonalesInfo, SetUltimaAdmisionPendiente, SetAdmisionPreExistente }) => {

    const { TipoCif, ListIdentificadores, ListGeneros, ListEstadosCivil, CodigoVerificado, ListCampReq, FechaNacimiento, Credenciales, Cliente, ActivadorBotones } = DatosPresonalesInfo;

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

    const { etiquetas, codigoIdioma, dispatch} = useGlobalState();

    const [identificacionPatron, setIdentificacionPatron] = useState({
        mascara: '',
        patron: '',
        minimo: 0,
        maximo: 30
    });

    const [deshabilitarElementos, setDeshabilitarElementos] = useState(false);

    const isMailDisabled = Cliente.Info.cusCustomerId !== '00000000-0000-0000-0000-000000000000' || Credenciales.Info.customerId !== '00000000-0000-0000-0000-000000000000'

    const [formatoFecha, setFormatoFecha] = useState('dd/MM/yyyy');

    const ejecutarValidarToken = async (codigo) => {
        if (ValidarFormatoUUID(codigo)) {
            dispatch({ type: "LOAD_HOME", texto: etiquetas.CargandoModal.Et_Procesando });
            const validacionResponse = await validarToken(Credenciales.Info.customerId, codigo, dispatch);
            if (validacionResponse === true) {                
                const lastAdmission = await buscarUltAdmisionPendiente({
                    CustomerId: Credenciales.Info.customerId,
                    CompanyId: Credenciales.Info.companyId
                });

                await obtenerEstudianteInfo(Credenciales.Info.customerId, Cliente.SetInfo, dispatch);

                SetAdmisionPreExistente(false);
                if (lastAdmission !== null && lastAdmission !== undefined && lastAdmission !== '00000000-0000-0000-0000-000000000000') {
                    SetAdmisionPreExistente(true);
                    SetUltimaAdmisionPendiente(lastAdmission);                    
                }
                mostrarDialogoCodigoVerificacion();
            } else {
                MostrarMensaje(dispatch, 'error', ["ErrorValidUUID"]);
            }
            CodigoVerificado.SetInfo(validacionResponse);
            
            dispatch({ type: "CLOSE_LOAD_HOME" });
        } else {
            MostrarMensaje(dispatch, 'error', ["ErrorValidFormatUUID"]);
        }
    };

    const ejecutarObtenerToken = async (e) => {
        e.preventDefault();
        if (ValidarFormatoCorreo(Credenciales.Info.email) === true) {
            dispatch({ type: "LOAD_HOME", texto: etiquetas.CargandoModal.Et_Procesando });

            await obtenerToken(Credenciales.Info.customerId, Credenciales.Info.companyId, dispatch);
            
            dispatch({ type: "CLOSE_LOAD_HOME" });
        } else {
            MostrarMensaje(dispatch, 'warning', ["ErrorRequiredEmail"]);
        }
    };

    const cancelarValidarToken = async () => {
        CodigoVerificado.SetInfo(false);
        limpiarCliente();
        mostrarDialogoCodigoVerificacion();
    };

    const obtenerEstudiante = async (typeIde = null) => {
        setDeshabilitarElementos(true);      
        dispatch({ type: "LOAD_HOME", texto: etiquetas.CargandoModal.Et_Procesando });        
        if (TipoCif !== '00000000-0000-0000-0000-000000000000' && Cliente.Info.cusIde !== '') {
        
            const EstudianteData = await existeEstudianteInfo(Cliente.Info.cusIde, (typeIde === null ? Cliente.Info.cusTypeIdeFk : typeIde), Credenciales.SetInfo, dispatch);
        
            if (EstudianteData.CustomerId !== '00000000-0000-0000-0000-000000000000') {
                
                limpiarCliente(false, typeIde);

                await obtenerToken(EstudianteData.CustomerId, EstudianteData.CompanyId, dispatch);

                mostrarDialogoCodigoVerificacion();

            } else {
                CodigoVerificado.SetInfo(true);
            }

            await LoadCamposrequeridos(EstudianteData.CompanyId, 'S', EstudianteData.Language, EstudianteData.CustomerId, ListCampReq.SetInfo, dispatch);
        
        } else {
            limpiarCliente(true, typeIde);
            CodigoVerificado.SetInfo(false);
        }

        ActivadorBotones.SetInfo(true);
        setDeshabilitarElementos(false);
        dispatch({ type: "CLOSE_LOAD_HOME" });

    };

    const ingresarValoresMemoria = e => {
        const { name, value } = e.target;  // se desestructura del targen el nombre y el valor que trae
        
        // se usa el hook de useState sobre la variable de estado local y se actualiza solo la propiedad que concuerda con el
        // valor que se le envia lo demas se queda igual 
        Cliente.SetInfo((anterior) => ({
            ...anterior,
            [name]: value
        }));

        if (name === 'cusIde') {
            
            ActivadorBotones.SetInfo(false);

        } else if (name === 'cusTypeIdeFk' && Cliente.Info.cusCustomerId === '00000000-0000-0000-0000-000000000000') {
           
            obtenerEstudiante(value);
            
        }

    };

    useEffect(() => {

        let maskIde = '';
        let pattIde;
        let minimo = 0;
        let maximo = 30;

        if (Cliente.Info.cusTypeIdeFk !== '' && Cliente.Info.cusTypeIdeFk !== '00000000-0000-0000-0000-000000000000' && ListIdentificadores.length > 0) {
            const tipoIdentificacion = ListIdentificadores.find((ideType) => ideType.idtIdeTypeId === Cliente.Info.cusTypeIdeFk);

            if (tipoIdentificacion) {
                maskIde = tipoIdentificacion.idtMask;
                minimo = tipoIdentificacion.idtMinLength;
                maximo = tipoIdentificacion.idtMaxLength;
                try {
                    pattIde = new RegExp(tipoIdentificacion.idtRegularExp);
                } catch (e) { }
            }
        }
        
        setIdentificacionPatron({
            mascara: maskIde,
            patron: pattIde,
            minimo: minimo,
            maximo: maximo
        });

    }, [Cliente.Info.cusTypeIdeFk]);

    const validarMinimoIdentificacion = () => {
        if (Cliente.Info.cusIde.trim().length < identificacionPatron.minimo) {
            const valorMinimo = Cliente.Info.cusIde.trim().length.toString();
            const valorPermitido = identificacionPatron.minimo.toString();
            const mensajeMinimo = format(etiquetas.InterfazDatosPersonales.Et_tblValidIdeMinimo, valorMinimo, valorPermitido);
            MostrarMensaje(dispatch, 'warning', [mensajeMinimo]);
            return false;
        }
        else
            return true;
    };

    const validarMaximoIdentificacion = () => {
        if (Cliente.Info.cusIde.trim().length > identificacionPatron.maximo) {
            const valorMaximo = Cliente.Info.cusIde.trim().length.toString();
            const valorPermitido = identificacionPatron.maximo.toString();
            const mensajeMaximo = format(etiquetas.InterfazDatosPersonales.Et_tblValidIdeMaximo, valorMaximo, valorPermitido);
            MostrarMensaje(dispatch, 'warning', [mensajeMaximo]);
            return false;
        }
        else
            return true;
    };

    const validarFormatoIdentificacion = () => {
        
        if (identificacionPatron.patron !== undefined && identificacionPatron.patron !== null) {
            var ideValidateResult = identificacionPatron.patron.test(Cliente.Info.cusIde.trim());
            if (!ideValidateResult) {
                const mensajeValidacion1 = identificacionPatron.mascara !== "" ? format(etiquetas.InterfazDatosPersonales.Et_tblIdeFormato, identificacionPatron.mascara) : '';
                const mensajeValidacion2 = format(etiquetas.InterfazDatosPersonales.Et_tblValidIdeFormato, mensajeValidacion1);
                MostrarMensaje(dispatch, 'warning', [mensajeValidacion2.trim()]);
            }
            return ideValidateResult;
        }
    };

    async function salvarCliente() {

        dispatch({ type: "LOAD_HOME", texto: etiquetas.CargandoModal.Et_Procesando });
        
        if (ValidarFormatoFecha(FechaNacimiento.Info)) {
            //Objeto para el Cliente 
            const objetoCliente = {
                CusCustomerId: Cliente.Info.cusCustomerId,
                CusIde: Cliente.Info.cusIde,
                CusTypeIdeFk: Cliente.Info.cusTypeIdeFk,
                CusOtherIde: Cliente.Info.cusCustomerId !== '00000000-0000-0000-0000-000000000000' ? Cliente.Info.cusOtherIde : Cliente.Info.cusIde,
                CusName: Cliente.Info.cusName,
                CusLastName1: Cliente.Info.cusLastName1,
                CusLastName2: Cliente.Info.cusLastName2,
                CusDateBirth: FechaNacimiento.Info,
                CusGenderFk: Cliente.Info.cusGenderFk,
                CusStatus: Cliente.Info.cusCustomerId !== '00000000-0000-0000-0000-000000000000' ? Cliente.Info.cusStatus : true,
                CusCivilStatusFk: Cliente.Info.cusCivilStatusFk,
                CifTypeIdFk: TipoCif,
                CompanyId: Credenciales.Info.companyId,
                UserId: Credenciales.Info.userId
            };


            const validacionCampos = ValidarPropiedad(ListCampReq.Info, objetoCliente, dispatch);

            if (!isMailDisabled) {
                if (Cliente.Info.cusMail === '' || ValidarFormatoCorreo(Cliente.Info.cusMail) !== true) {
                    MostrarMensaje(dispatch, 'warning', ["ErrorValidEmailFormat"]);
                    dispatch({ type: "CLOSE_LOAD_HOME" })
                    return;
                }

                const result = await validarEmailRegistro(Cliente.Info.cusMail, dispatch);
                if (result !== true) {                    
                    dispatch({ type: "CLOSE_LOAD_HOME" })
                    return;
                }
            }

            if (!validarMinimoIdentificacion()) {
                dispatch({ type: "CLOSE_LOAD_HOME" })
                return;
            }

            if (!validarMaximoIdentificacion()) {
                dispatch({ type: "CLOSE_LOAD_HOME" })
                return;
            }

            if (!validarFormatoIdentificacion()) {
                dispatch({ type: "CLOSE_LOAD_HOME" })
                return;
            }

            if (validacionCampos) {

                if (Cliente.Info.cusCustomerId !== '00000000-0000-0000-0000-000000000000') {
                    actualizarCliente(objetoCliente, dispatch);
                }
                else {
                    
                    const newCustomerId = await insertarCliente(objetoCliente, dispatch);
                    
                    if (newCustomerId !== '00000000-0000-0000-0000-000000000000') {
                       
                        const objetoMail = {
                            CustomerId: newCustomerId,         
                            Email: Cliente.Info.cusMail,        
                            CompanyId: Credenciales.Info.companyId,
                            UserId: Credenciales.Info.userId,
                        };

                        const resultOk = await guardarMail(objetoMail, dispatch);

                        const EstudianteData = await existeEstudianteInfo(Cliente.Info.cusIde, Cliente.Info.cusTypeIdeFk, Credenciales.SetInfo, dispatch);
                        
                        await LoadCamposrequeridos(EstudianteData.CompanyId, 'S', EstudianteData.Language, EstudianteData.CustomerId, ListCampReq.SetInfo, dispatch);
                        
                        if(resultOk){                            
                            await obtenerToken(EstudianteData.CustomerId, EstudianteData.CompanyId, dispatch);
                        }
                    
                    }
                }
            }
        } else {
            MostrarMensaje(dispatch, 'error', ["ErrorValidDateFormat"]);
        }
        dispatch({ type: "CLOSE_LOAD_HOME" });
    };

    const limpiarCliente = async (CusIde = true, typeIde = null) => {   
        let typeIdeId = (ListIdentificadores.length > 0 ? ListIdentificadores[0].idtIdeTypeId : '00000000-0000-0000-0000-000000000000');

        Cliente.SetInfo({
            cusCustomerId: '00000000-0000-0000-0000-000000000000',
            cusIde: CusIde ? '' : Cliente.Info.cusIde,
            cusTypeIdeFk: typeIde === null ? typeIdeId : typeIde,
            cusOtherIde: '',
            cusName: '',
            cusLastName1: '',
            cusLastName2: '',
            cusDateBirth: Date,
            cusGenderFk: ListGeneros.length > 0 ? ListGeneros[0].genGenderId : '00000000-0000-0000-0000-000000000000',
            cusStatus: true,
            cusCivilStatusFk: ListEstadosCivil.length > 0 ? ListEstadosCivil[0].cisCivilStatusId : '00000000-0000-0000-0000-000000000000',
            cusMail: ''
        });
        CodigoVerificado.SetInfo(false);
        if (CusIde) {
            Credenciales.SetInfo({
                companyId: '00000000-0000-0000-0000-000000000000',
                customerCIF: '',
                customerId: '00000000-0000-0000-0000-000000000000',
                defaultLanguage: "ES",
                email: '',
                imagen: null,
                imagenPerfil: null,
                nombreCompleto: '',
                state: true,
                token: '',
                userId: '00000000-0000-0000-0000-000000000000',
                username: ''
            });
        }
    };

    const generaEtiquetaIdentificacion = (obligatorio) => {
        let texto = etiquetas.General.Et_tblCusIde;

        let etiIde = false;

        let etiquetaIdentificacion = LlavesConfiguraciones.etiquetaIdentificacion;
        if (etiquetaIdentificacion !== null && etiquetaIdentificacion !== undefined)
            if (etiquetaIdentificacion)
                etiIde = true;

        if (etiIde)
            texto += ' / ' + etiquetas.InterfazClienteContactInfo.Et_tblPhone;

        if (obligatorio)
            texto += ' *';

        return texto;
    };


    const fechaRango = (anio = 100) => {

        const date = new Date() 
        const year =  date.getFullYear() - anio;
        const day = ('0' + date.getDay()).slice(-2);
        const month = ('0' + date.getMonth()).slice(-2);
        
        return new Date(`${year}-${month}-${day}`);

    }

    return (
        <Fragment>
            <CardHeader
                style={{ paddingBottom: 0 }}
                title={
                    <Typography style={{ ...StyleHomeHeader.HeaderText, ...{ fontSize: 24, textAlign: 'center', marginLeft: 0 } }}>
                        {etiquetas.Home.Et_lblDatosPersonales}
                    </Typography>} />
            <CardActions style={{ justifyContent:  deviceIs === MOBILE ? 'center' :'flex-end', marginRight: deviceIs === MOBILE  ? 0 : 31 }}>
                <Button
                    style={{ ...modalesMensajesGenericos.BotonesNo, ...{ width: deviceIs === MOBILE  ? "47.5%" : 'auto', cursor: CodigoVerificado.Info === true && ActivadorBotones.Info === true ? 'pointer' : 'default' } }}
                    disabled={CodigoVerificado.Info === false || ActivadorBotones.Info === false} aria-label="limpiar info"
                    onClick={() => {
                            SetAdmisionPreExistente(false);
                            SetUltimaAdmisionPendiente('00000000-0000-0000-0000-000000000000');
                            limpiarCliente();
                        }
                    }>
                    {etiquetas.General.Et_tbnLimpiar}
                </Button>
                <Button
                    style={{ ...modalesMensajesGenericos.BotonesOk, ...{ width: deviceIs === MOBILE  ?"47.5%" :'auto', cursor: CodigoVerificado.Info === true && ActivadorBotones.Info === true ? 'pointer' : 'default', marginLeft: 0 } }}
                    disabled={CodigoVerificado.Info === false || ActivadorBotones.Info === false} aria-label="guardar info"
                    onClick={salvarCliente}>
                    {etiquetas.General.Et_tbnGuardar}
                </Button>
            </CardActions>
                
            <CardContent sx={deviceIs === MOBILE  ? { padding:'0px'  } : {}}>
                <Grid container style={deviceIs === MOBILE  ? { backgroundColor:'#fff' } : StyleHome.GridConteiner}>
                    <Grid item xs={deviceIs === MOBILE  ? 12 : 4} sm={4} md={4} style={StyleHome.GridItem}>
                       
                        <TextField
                            disabled={Cliente.Info.cusCustomerId !== '00000000-0000-0000-0000-000000000000'}                            
                            name="cusIde"
                            value={Cliente.Info.cusIde}
                            onBlur={(e) => {
                                e.preventDefault();
                                obtenerEstudiante(Cliente.Info.cusTypeIdeFk);
                            }}
                            onFocus={(e) => {
                                e.preventDefault();
                                setDeshabilitarElementos(true);
                            }}
                            variant="outlined"
                            fullWidth
                            label={generaEtiquetaIdentificacion(Enumerable.from(ListCampReq.Info).any(x => x.code === 'cusIde'))}
                            onChange={(e) => {                                
                                ingresarValoresMemoria(e);
                            }}
                            placeholder={identificacionPatron.mascara}
                            inputProps={{
                                maxLength: identificacionPatron.maximo
                            }}>
                        </TextField>
                    </Grid>    
                    <Grid item xs={deviceIs === MOBILE  ? 12 : 4} sm={4} md={4} style={StyleHome.GridItem}>
                      
                        <FormControl fullWidth variant="outlined">
                            <InputLabel id="cusTypeIdeFk-label">
                                {Enumerable.from(ListCampReq.Info).any(x => x.code === 'cusTypeIdeFk') ?
                                    fullScreen ? etiquetas.InterfazDatosPersonales.Et_tblCusTypeIdeFkShort : etiquetas.InterfazDatosPersonales.Et_tblCusTypeIdeFk + ' *' :
                                    fullScreen ? etiquetas.InterfazDatosPersonales.Et_tblCusTypeIdeFkShort : etiquetas.InterfazDatosPersonales.Et_tblCusTypeIdeFk}
                            </InputLabel>
                            <Select name="cusTypeIdeFk" value={Cliente.Info.cusTypeIdeFk} onChange={ingresarValoresMemoria}
                                disabled={Cliente.Info.cusCustomerId !== '00000000-0000-0000-0000-000000000000' || deshabilitarElementos}
                                label={Enumerable.from(ListCampReq.Info).any(x => x.code === 'cusTypeIdeFk') ?
                                    fullScreen ? etiquetas.InterfazDatosPersonales.Et_tblCusTypeIdeFkShort : etiquetas.InterfazDatosPersonales.Et_tblCusTypeIdeFk + ' *' :
                                    fullScreen ? etiquetas.InterfazDatosPersonales.Et_tblCusTypeIdeFkShort : etiquetas.InterfazDatosPersonales.Et_tblCusTypeIdeFk
                                }
                                labelId="cusTypeIdeFk-label"
                            >
                                {ListIdentificadores.map((identificacdor) => (<MenuItem key={"ident-" + identificacdor.idtIdeTypeId} value={identificacdor.idtIdeTypeId}>{identificacdor.idtDsc}</MenuItem>))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={deviceIs === MOBILE  ? 12 : 4} sm={4} md={4} style={StyleHome.GridItem}>
                        {Cliente.Info.cusCustomerId !== '00000000-0000-0000-0000-000000000000' || Credenciales.Info.customerId !== '00000000-0000-0000-0000-000000000000' ? null :
                            <TextField
                                name="cusMail"
                                error={Cliente.Info.cusMail ? 
                                    ValidarFormatoCorreo(Cliente.Info.cusMail) === false && Cliente.Info.cusMail !== '' :
                                    false
                                }
                                disabled={CodigoVerificado.Info === false || deshabilitarElementos}
                                value={Cliente.Info.cusMail}
                                variant="outlined"
                                fullWidth
                                label={etiquetas.InterfazClienteContactInfo.Et_tblEmail + ' *' }
                                onChange={ingresarValoresMemoria}
                                inputProps={{
                                    maxLength: 200
                                }}>
                            </TextField>
                        }
                    </Grid>
                    <Grid item xs={deviceIs === MOBILE  ? 12 : 4} sm={4} md={4} style={StyleHome.GridItem}>
                        <TextField
                            disabled={CodigoVerificado.Info === false || deshabilitarElementos}
                            name="cusName"
                            value={Cliente.Info.cusName}
                            variant="outlined"
                            fullWidth
                            label={Enumerable.from(ListCampReq.Info).any(x => x.code === 'cusName') ?
                                etiquetas.General.Et_tblNombre + ' *' :
                                etiquetas.General.Et_tblNombre
                            }
                            onChange={ingresarValoresMemoria}
                            inputProps={{
                                maxLength: 50
                            }}></TextField>
                    </Grid>
                    <Grid item xs={deviceIs === MOBILE  ? 12 : 4} sm={4} md={4} style={StyleHome.GridItem}>
                        <TextField
                            disabled={CodigoVerificado.Info === false || deshabilitarElementos}
                            name="cusLastName1"
                            value={Cliente.Info.cusLastName1}
                            variant="outlined"
                            fullWidth
                            label={Enumerable.from(ListCampReq.Info).any(x => x.code === 'cusLastName1') ?
                                etiquetas.InterfazDatosPersonales.Et_tblCusLastName1 + ' *' :
                                etiquetas.InterfazDatosPersonales.Et_tblCusLastName1
                            }
                            onChange={ingresarValoresMemoria}
                            inputProps={{
                                maxLength: 50
                            }}></TextField>
                    </Grid>
                    <Grid item xs={deviceIs === MOBILE  ? 12 : 4} sm={4} md={4} style={StyleHome.GridItem}>
                        <TextField
                            disabled={CodigoVerificado.Info === false || deshabilitarElementos}
                            name="cusLastName2"
                            value={Cliente.Info.cusLastName2}
                            variant="outlined"
                            fullWidth
                            label={Enumerable.from(ListCampReq.Info).any(x => x.code === 'cusLastName2') ?
                                etiquetas.InterfazDatosPersonales.Et_tblCusLastName2 + ' *' :
                                etiquetas.InterfazDatosPersonales.Et_tblCusLastName2
                            }
                            onChange={ingresarValoresMemoria}
                            inputProps={{
                                maxLength: 50
                            }}></TextField>
                    </Grid>
                    <Grid item xs={deviceIs === MOBILE  ? 12 : 4} sm={4} md={4} style={StyleHome.GridItem}>
                        <LocalizationProvider dateAdapter={AdapterDateFns} locale={codigoIdioma === "EN" ? en : es}>
                            <DesktopDatePicker
                                disabled={CodigoVerificado.Info === false || deshabilitarElementos}
                                required
                                format="YYYY-MM-DD"
                                inputFormat={formatoFecha}
                                id="fecha-nacimiento-id"
                                name="CusDateBirth"
                                value={FechaNacimiento.Info}
                                minDate={fechaRango()}
                                maxDate={new Date()}
                                variant="outlined"
                                label={Enumerable.from(ListCampReq.Info).any(x => x.code === 'CusDateBirth') ?
                                    etiquetas.InterfazDatosPersonales.Et_tblFechaNacimiento + ' *' :
                                    etiquetas.InterfazDatosPersonales.Et_tblFechaNacimiento
                                }
                                onChange={(newValue) => {
                                    FechaNacimiento.SetInfo(newValue);
                                }}
                                renderInput={(params) => <TextField fullWidth {...params} />}
                            />
                        </LocalizationProvider>
                    </Grid>
                    <Grid item xs={deviceIs === MOBILE  ? 12 : 4} sm={4} md={4} style={StyleHome.GridItem}>
                        <FormControl fullWidth variant="outlined">
                            <InputLabel id="cusGenderFk-label">
                                {Enumerable.from(ListCampReq.Info).any(x => x.code === 'cusGenderFk') ?
                                    etiquetas.InterfazDatosPersonales.Et_tblCusGenderFk + ' *' :
                                    etiquetas.InterfazDatosPersonales.Et_tblCusGenderFk}
                            </InputLabel>
                            <Select name="cusGenderFk" value={Cliente.Info.cusGenderFk} onChange={ingresarValoresMemoria}
                                disabled={CodigoVerificado.Info === false || deshabilitarElementos}
                                labelId="cusGenderFk-label"
                                label={Enumerable.from(ListCampReq.Info).any(x => x.code === 'cusGenderFk') ?
                                    etiquetas.InterfazDatosPersonales.Et_tblCusGenderFk + ' *' :
                                    etiquetas.InterfazDatosPersonales.Et_tblCusGenderFk
                                }
                            >
                                {ListGeneros.map((genero) => (<MenuItem key={"genero-" + genero.genGenderId} value={genero.genGenderId}>{genero.genDsc}</MenuItem>))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={deviceIs === MOBILE ? 12 : 4} sm={4} md={4} style={StyleHome.GridItem}>
                        <FormControl fullWidth variant="outlined">
                            <InputLabel id="cusCivilStatusFk-label">
                                {Enumerable.from(ListCampReq.Info).any(x => x.code === 'cusCivilStatusFk') ?
                                    (fullScreen ? etiquetas.InterfazDatosPersonales.Et_tblCusCivilStatusFkShort : etiquetas.InterfazDatosPersonales.Et_tblCusCivilStatusFk) + ' *' :
                                    (fullScreen ? etiquetas.InterfazDatosPersonales.Et_tblCusCivilStatusFkShort : etiquetas.InterfazDatosPersonales.Et_tblCusCivilStatusFk)}
                            </InputLabel>
                            <Select name="cusCivilStatusFk" value={Cliente.Info.cusCivilStatusFk} onChange={ingresarValoresMemoria}
                                disabled={CodigoVerificado.Info === false || deshabilitarElementos}
                                labelId="cusCivilStatusFk-label"
                                label={Enumerable.from(ListCampReq.Info).any(x => x.code === 'cusCivilStatusFk') ?
                                    (fullScreen ? etiquetas.InterfazDatosPersonales.Et_tblCusCivilStatusFkShort : etiquetas.InterfazDatosPersonales.Et_tblCusCivilStatusFk) + ' *' :
                                    (fullScreen ? etiquetas.InterfazDatosPersonales.Et_tblCusCivilStatusFkShort : etiquetas.InterfazDatosPersonales.Et_tblCusCivilStatusFk)
                                }
                            >
                                {ListEstadosCivil.map((estadoCivil) => (<MenuItem key={"estadoCivil-" + estadoCivil.cisCivilStatusId} value={estadoCivil.cisCivilStatusId}>{estadoCivil.cisDsc}</MenuItem>))}
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
            </CardContent>
            
            <DialogoCodigoVerificacion 
            deviceIs={deviceIs}
            EjecutarValidarToken={ejecutarValidarToken} 
            EjecutarObtenerToken={ejecutarObtenerToken} 
            CancelarValidarToken={cancelarValidarToken}/>
        </Fragment>
    );
};

export default DatosPersonales;